import { render, staticRenderFns } from "./AddDistribution.vue?vue&type=template&id=b67d5750&scoped=true&"
import script from "./AddDistribution.vue?vue&type=script&lang=js&"
export * from "./AddDistribution.vue?vue&type=script&lang=js&"
import style0 from "./AddDistribution.vue?vue&type=style&index=0&id=b67d5750&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67d5750",
  null
  
)

export default component.exports